var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRugbyLeague = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "American-Football-Run-Ball--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "American Football Run Ball Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.4 2.5a2.5 2.5 0 1 0 5 0 2.5 2.5 0 1 0 -5 0",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.53 5.09a0.26 0.26 0 0 0 -0.23 0.41 2 2 0 0 1 0.45 1.19l0 2.13a0.7 0.7 0 0 1 -0.38 0.64l-1.66 0.64a1.5 1.5 0 0 0 -0.9 1.9 1.53 1.53 0 0 0 1.94 0.86l1.75 -0.68a3.74 3.74 0 0 0 2 -4.73 3.8 3.8 0 0 0 -2.97 -2.36Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.88 16.14a1.5 1.5 0 0 0 -2 -2.28L18 15.51a1.49 1.49 0 0 1 -1.69 0.18l-2.77 -1.51a0.25 0.25 0 0 1 -0.14 -0.18v-1a0.27 0.27 0 0 0 -0.08 -0.19 0.26 0.26 0 0 0 -0.19 -0.06H13a2 2 0 0 1 -2.05 -2 7 7 0 0 1 0.51 -3 0.25 0.25 0 0 0 -0.33 -0.33L7.72 8.91a2.61 2.61 0 0 1 -1 0.19 2.39 2.39 0 0 1 -1 -0.22l-2 -1a1.5 1.5 0 0 0 -1.22 2.74l2 1a5.33 5.33 0 0 0 2.22 0.47 5.67 5.67 0 0 0 2.17 -0.43L10.4 11v3.09l-2.51 1.24a4.47 4.47 0 0 0 -2.49 4v3.17a1.5 1.5 0 1 0 3 0v-3.15A1.5 1.5 0 0 1 9.23 18l2.64 -1.32 3 1.64a4.6 4.6 0 0 0 2.15 0.54A4.52 4.52 0 0 0 20 17.79Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.93 10.48a2.45 2.45 0 0 1 1.39 -1.31l0.51 -0.2a0.28 0.28 0 0 0 0.17 -0.15 5.64 5.64 0 0 0 0.28 -2.06 0.56 0.56 0 0 0 -0.66 -0.51 4.75 4.75 0 0 0 -2.76 1.5 4.74 4.74 0 0 0 -0.8 3 0.55 0.55 0 0 0 0.55 0.52h0.1a6 6 0 0 0 1 -0.28 0.23 0.23 0 0 0 0.16 -0.17 1.82 1.82 0 0 1 0.06 -0.34Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRugbyLeague);
export default ForwardRef;